import { cond, curry, pipe, prop } from 'ramda';

export const propCond = curry((propName, conditionals) => pipe(prop(propName), cond(conditionals)));
